<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index">{{paragraph}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
          article: {
            cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_1.jpg',
            title: '找人合租房，你想好了嗎？',
            tags: ['房東', '房客', '合租', '租屋', '套房', '房租'],
            content: ['房價貴鬆鬆，租房的人越來越多，隨之租金也悄悄地跟著成長，在租客負擔不起高租金又想享有好的住屋品質下，越來越多租客選擇找人合租房，從中減輕房租帶來的負擔。但找人合租前，房租分攤問題、公共費用及公共空間維護問題這些你都想過了嗎？最怕那種曾經是好朋友，合租房後變成老死不相往來的陌生人，撇開你的租金減低了，這些眉眉角角真的能讓你有好的居住品質嗎？因此，合租房前提醒你先做好以下的準備。', '房租的分攤', '房租要如何分攤，有些共用衛浴、有些是獨立套房、有些是雙人房、有些是單人房，是要依照房間大小還是均分費用，又或者是按照人頭數算，這些都會影響未來租金的繳交，無論是哪種分攤方式，都建議租客們在事前先與未來的室友討論清楚，避免未來再繳交房租時出現問題。', '公共費用的分攤', '多數合租房都不會裝設獨立電錶，水費及瓦斯費皆為共用，但偏偏每個人的生活習慣不同，用量也不同，有些人喜歡在家開伙、有些人洗澡時間較長、有些人不吹冷氣睡不著，這些問題要如何解決，如何公平分攤這些公共費用，建議要在事前先說清楚，以免未來遇到大家使用量不同，心中產生不平衡的疙瘩出現。', '公共空間的維護', '找人合租房優點之一就是擁有較大的公共活動空間，偏偏公共空間的維護就像學校的公共區域需要有人打掃，小至倒垃圾、大至廁所清掃，就像值日生輪職表一樣，可訂定出一份打掃公約，明確規劃公共區域的整潔如何維護。', '上述列出幾項合租房前的注意事項，最後還要再提醒所有合租客，過去合租房簽訂租約時，為省去麻煩，房東多只會與一位主要承租人簽署租約，這樣的方式仍會出現許多小糾紛，房客們可以嘗試與房東討論是否每一位房客分別獨立簽署租約，清楚地將上述事項做一個記載，以免未來問題發生後找不到責任歸屬人。']
          }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_1.vue